/* eslint-disable react-hooks/exhaustive-deps */
import { Input } from "@/components/ui/input";
import { useEffect, useState } from "react";

export const KeyUpdateInput = ({
  value,
  onChange,
}: // setIsDisable,
{
  value: string;
  onChange: (prop: string) => void;
  list?: string[];
  setIsDisable: (prop: boolean) => void;
}) => {
  const [data, setData] = useState("");
  const [error, setError] = useState<string | undefined>(undefined);

  const isValidEmail = (email: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  useEffect(() => {
    if (data !== value) {
      setData(value);
    }
  }, [value]);

  useEffect(() => {
    setError(undefined);
    if (data === "") {
      // onChange(data); // ✅ only push valid emails
    } else if (isValidEmail(data)) {
      onChange(data); // ✅ only push valid emails
    } else {
      setError("Invalid email");
    }
  }, [data]);

  return (
    <div className="relative">
      <Input
        onFocus={() => {
          // setIsDisable(true);
        }}
        // onClick={() => setEdit()}
        value={data}
        onChange={(e) => setData(e.target.value)}
        placeholder="Enter email"
        className="h-[43px]"
        // onKeyDown={() => {

        // }}
      />
      {error ? <p style={{ color: "red", fontSize: "12px" }}>{error}</p> : null}
    </div>
  );
};
